enum ActionType {
    SET_WATCHED_INCIDENTS = '[WATCH INCIDENTS] SET WATCHED INCIDENTS',
    SET_LOADING = '[WATCH INCIDENTS] SET LOADING',
    SET_ERROR = '[WATCH INCIDENTS] SET ERROR',
}

export default ActionType
